// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import api from '../services/api';
import notify from '../utils/toast';
import { useAuth } from '../context/AuthContext';
import { useI18n } from '../context/I18nContext';
import ActionButtons from '../components/ActionButtons';

export default function Payments() {
    const [payments, setPayments] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchParams] = useSearchParams();
    const statusFilter = searchParams.get('status') || '';
    const { can } = useAuth();
    const { t, td} = useI18n();

    const load = () => {
        setLoading(true);
        const params = {};
        if (statusFilter) params.status = statusFilter;
        api.get('/payments', { params })
            .then((res) => setPayments(res.data.data))
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        load();
    }, [statusFilter]);

    const approve = async (id) => {
        if (!window.confirm(t('confirmApprove'))) return;
        try {
            await api.post(`/payments/${id}/approve`);
            notify.success(t('successApprove'));
            load();
        } catch (err) {
            notify.apiError(err);
        }
    };

    const reject = async (id) => {
        if (!window.confirm(t('confirmReject'))) return;
        try {
            await api.post(`/payments/${id}/reject`);
            notify.success(t('successReject'));
            load();
        } catch (err) {
            notify.apiError(err);
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm('Delete this payment record?')) return;
        try {
            await api.delete(`/payments/${id}`);
            load();
        } catch (err) {
            notify.apiError(err);
        }
    };

    const showActions = can('payments.approve') || can('payments.delete') || can('payments.view');

    return (
        <div>
            <div className="d-flex justify-content-between align-items-center mb-4">
                <div>
                    <h4 className="mb-1">Payments</h4>
                    <p className="text-muted mb-0">Payment entries & approval workflow</p>
                </div>
                {can('payments.create') && (
                    <span className="badge bg-secondary">Record via booking detail</span>
                )}
            </div>

            <div className="card table-card">
                <div className="table-responsive">
                    <table className="table table-hover mb-0">
                        <thead className="table-light">
                            <tr>
                                <th>Receipt</th>
                                <th>Customer</th>
                                <th>Booking</th>
                                <th>Amount</th>
                                <th>Date</th>
                                <th>Method</th>
                                <th>Status</th>
                                {showActions && <th>Actions</th>}
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan={8} className="text-center py-4">
                                        <div className="spinner-border spinner-border-sm text-success" />
                                    </td>
                                </tr>
                            ) : payments.length === 0 ? (
                                <tr>
                                    <td colSpan={8} className="text-center text-muted py-4">
                                        No payments found
                                    </td>
                                </tr>
                            ) : (
                                payments.map((p) => (
                                    <tr key={p.id}>
                                        <td className="fw-semibold">{p.receipt_no}</td>
                                        <td>{p.customer?.name}</td>
                                        <td>{p.booking?.booking_no}</td>
                                        <td>৳ {Number(p.amount).toLocaleString()}</td>
                                        <td>{p.payment_date}</td>
                                        <td className="text-capitalize">
                                            {p.payment_method?.replace('_', ' ')}
                                        </td>
                                        <td>
                                            <span
                                                className={`badge bg-${
                                                    p.status === 'approved'
                                                        ? 'success'
                                                        : p.status === 'rejected'
                                                          ? 'danger'
                                                          : 'warning'
                                                }`}
                                            >
                                                {td('status', p.status)}
                                            </span>
                                        </td>
                                        {showActions && (
                                            <td>
                                                <ActionButtons
                                                    canView={false}
                                                    canEdit={false}
                                                    canDelete={can('payments.delete') && p.status === 'pending'}
                                                    canApprove={
                                                        can('payments.approve') && p.status === 'pending'
                                                    }
                                                    onApprove={() => approve(p.id)}
                                                    onReject={() => reject(p.id)}
                                                    onDelete={() => handleDelete(p.id)}
                                                    approveTitle="Approve payment"
                                                    rejectTitle="Reject payment"
                                                />
                                            </td>
                                        )}
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}
